/**
 * Military Affiliation Data
 *
 * Static option lists for the military affiliation section
 * in the Join the Movement email subscription form.
 */

export interface MilitaryOption {
  value: string
  label: string
}

export interface MilitaryRankGroup {
  group: string
  ranks: MilitaryOption[]
}

// ============================================================================
// Military Status Options
// ============================================================================

export const MILITARY_STATUSES: readonly MilitaryOption[] = [
  { value: 'active-duty', label: 'Active Duty' },
  { value: 'guard-reserves', label: 'Guard/Reserves' },
  { value: 'veteran-separated', label: 'Veteran — Separated' },
  { value: 'veteran-retired', label: 'Veteran — Retired' },
  { value: 'veteran-medically-retired', label: 'Veteran — Medically Retired' },
] as const

// ============================================================================
// Military Branch Options
// ============================================================================

export const MILITARY_BRANCHES: readonly MilitaryOption[] = [
  { value: 'army', label: 'Army' },
  { value: 'navy', label: 'Navy' },
  { value: 'marines', label: 'Marines' },
  { value: 'air-force', label: 'Air Force' },
  { value: 'space-force', label: 'Space Force' },
  { value: 'coast-guard', label: 'Coast Guard' },
  { value: 'usphs', label: 'U.S. Public Health Service Commissioned Corps' },
  { value: 'noaa', label: 'NOAA Commissioned Corps' },
] as const

// ============================================================================
// Military Rank Options (Pay Grade)
// ============================================================================

export const MILITARY_RANK_GROUPS: readonly MilitaryRankGroup[] = [
  {
    group: 'Enlisted',
    ranks: [
      { value: 'E-1', label: 'E-1' },
      { value: 'E-2', label: 'E-2' },
      { value: 'E-3', label: 'E-3' },
      { value: 'E-4', label: 'E-4' },
      { value: 'E-5', label: 'E-5' },
      { value: 'E-6', label: 'E-6' },
      { value: 'E-7', label: 'E-7' },
      { value: 'E-8', label: 'E-8' },
      { value: 'E-9', label: 'E-9' },
    ],
  },
  {
    group: 'Warrant Officer',
    ranks: [
      { value: 'W-1', label: 'W-1' },
      { value: 'W-2', label: 'W-2' },
      { value: 'W-3', label: 'W-3' },
      { value: 'W-4', label: 'W-4' },
      { value: 'W-5', label: 'W-5' },
    ],
  },
  {
    group: 'Officer',
    ranks: [
      { value: 'O-1', label: 'O-1' },
      { value: 'O-2', label: 'O-2' },
      { value: 'O-3', label: 'O-3' },
      { value: 'O-4', label: 'O-4' },
      { value: 'O-5', label: 'O-5' },
      { value: 'O-6', label: 'O-6' },
      { value: 'O-7', label: 'O-7' },
      { value: 'O-8', label: 'O-8' },
      { value: 'O-9', label: 'O-9' },
      { value: 'O-10', label: 'O-10' },
    ],
  },
] as const
